import { render, staticRenderFns } from "./MuvekkilSecim.vue?vue&type=template&id=21f9fb08&scoped=true"
import script from "./MuvekkilSecim.vue?vue&type=script&lang=ts"
export * from "./MuvekkilSecim.vue?vue&type=script&lang=ts"
import style0 from "./MuvekkilSecim.vue?vue&type=style&index=0&id=21f9fb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f9fb08",
  null
  
)

export default component.exports